import React from "react";
import { motion } from "framer-motion";
import { Instagram as IgIcon } from "lucide-react";
import { Reveal } from "./Motion";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, ASSETS } from "../data/site";

export const InstagramSection = () => (
  <section
    data-testid="instagram-section"
    className="relative bg-[#050505] py-20 md:py-28"
  >
    <div className="max-w-[1400px] mx-auto px-4 md:px-10">
      <Reveal>
        <div className="relative overflow-hidden border border-white/10 bg-[#121212] p-8 md:p-14 flex flex-col lg:flex-row items-center justify-between gap-10">
          <div
            className="absolute inset-0 opacity-[0.08]"
            style={{
              backgroundImage: `url(${ASSETS.truckSide})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="relative z-10">
            <span className="font-mono-tech text-xs tracking-[0.25em] text-[#e60000] uppercase">
              / Redes sociais
            </span>
            <h2 className="mt-4 font-display font-bold uppercase text-white text-3xl md:text-5xl tracking-tight leading-[0.95]">
              Acompanhe a FS Guinchos
            </h2>
            <p className="mt-4 text-neutral-400 max-w-md">
              Confira nossos serviços, veículos e novidades no Instagram.
            </p>
            <p className="mt-3 font-mono-tech text-lg text-white">{INSTAGRAM_HANDLE}</p>
          </div>

          <motion.a
            data-testid="instagram-btn"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.04 }}
            className="relative z-10 inline-flex items-center gap-3 text-white font-bold uppercase tracking-wide px-8 py-5 shrink-0"
            style={{
              background:
                "linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)",
            }}
          >
            <IgIcon size={22} />
            Seguir no Instagram
          </motion.a>
        </div>
      </Reveal>
    </div>
  </section>
);
